import { createContext } from 'react';

export type Side = 'front' | 'back';

export interface SideContextValue {
  activeSide: Side;
  flipSide: () => void;
  setActiveSide: (side: Side) => void;
}

export const SideContext = createContext<SideContextValue | null>(null);
